import { Link } from 'react-router-dom';
import { GitCompareArrows } from 'lucide-react';

import { formatRelativeShort } from '@/helpers/date';
import { useRecentComparisonObject } from '@/data/recentComparison';

// A single recent comparison row inside the navigation rail's Compare flyout.
const ViewRecentComparisonForNavigation = ({ uid }) => {
  const recentComparison = useRecentComparisonObject(uid);

  // The comparison may have been deleted while still cached in the recent list —
  // the backend can no longer join it, so there is nothing to show.
  if (!recentComparison?.comparison) {
    return null;
  }

  const comparison = recentComparison.comparison;
  const recordCount = comparison.comparison_items?.length ?? 0;

  return (
    <Link
      to={`/comparison/${comparison.uid}`}
      data-testid={`nav-recent-comparison-${comparison.uid}`}
      className="flex items-center gap-3 rounded-xl p-2 hover:bg-accent transition-colors"
    >
      <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-record-comparison text-record-comparison-foreground">
        <GitCompareArrows className="size-4" />
      </div>
      <div className="min-w-0 flex-auto">
        <div className="truncate text-sm font-medium" data-testid={`nav-recent-comparison-${comparison.uid}-name`}>
          {comparison.label}
        </div>
        <div className="truncate text-xs text-muted-foreground">
          {formatRelativeShort(recentComparison.accessed_ts)} &bull; {recordCount} {recordCount === 1 ? 'record' : 'records'}
        </div>
      </div>
    </Link>
  );
};

export default ViewRecentComparisonForNavigation;
